// Filename - src/goodiebagdetails.js

import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { ArrowLeft, CheckCircleFill, PersonCheck, PersonCheckFill } from "react-bootstrap-icons";
import { collection, doc, getDocs, query, updateDoc, where, Timestamp } from "firebase/firestore";
import Header from './components/Header';
import Footer from './components/Footer';
import './goodiebagdetails.css'; // Import the new CSS file

const GoodieBagDetails = () => {

  const [name, setName] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [clubMembers, setClubMembers] = useState([]);
  const [showClubMembers, setShowClubMembers] = useState(false);

  const [roomno, setRoomNo] = useState(""); // state for the input value
  const [message, setMessage] = useState(""); // state for the feedback message
 
 
  localStorage.setItem('prvPnr', '');
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
      setName(user?.email);
  }, [user, loading]);
 
  const navigate = useNavigate();
  const [result, setResult] = useState("No result");

  const location = useLocation();
  const ticket = location.state.dTicket;

  const allowedFields = ["roommates", "riderprofile", "udf2", "transactionId", "amount", "club", "tshirt", "food", "name"];

  const fetchClubMembers = async (clubName) => {
    try {
    
      const q = query(
        collection(db, "RiderMania", "2026", "Registrations"), 
        where("club", "==", clubName)
      );
      const querySnapshot = await getDocs(q);
      const members = querySnapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(member => member.status === "success"); // Filter out members without PNR
       // Sort the users list 
       members.sort((a, b) => { 
        if (a.name < b.name) 
          return -1; 
        if (a.name > b.name) 
          return 1; 
        return 0; 
      });
        
      setClubMembers(members);
      setShowClubMembers(true);
    } catch (error) {
      console.error("Error fetching club members:", error);
    

      
    }
  };

  const removeStatusChecked = async (id) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to remove the goodie bag status?");
    
    if (!isConfirmed) {
      return; // Exit if user cancels
    }
  
    // Remove check-in data
    const checkinData = {
        goodieBagStatus:false
    } 
  
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
      await updateDoc(docRef, checkinData);
      
      // Update the local state to reflect the change
      setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, goodieBagStatus: false }
            : member
        )
      );  
        
    } catch (error) {
      console.error("Error removing goodie bag status:", error);
      alert("Error removing goodie bag status");
    } 
  };

  
  const updateStatusChecked = async (id) => {
    // remote Db update  
    const checkinData = {
      goodieBagStatus:true
    } 
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
    await  updateDoc(docRef, checkinData);
       // Update the local state to reflect the change
       setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, goodieBagStatus:true}
            : member
        )
      );  
        
    } catch (e) {
      console.error("Error updating goodie bag status:", e);
    } 
  
  };

  return (
      <>
      <div className="qr-details-page">
        <Header leftIcon="qr" />
        {user ? (
          <div className="container qr-details-container">
            <div className="details-card">
              {!showClubMembers ? (
                <>
                  <div className="card-header-container">
                    <button className="back-button-qr" onClick={() => navigate(-1)} title="Go Back">
                      <ArrowLeft size={28} />
                    </button>
                    <div className="card-header-custom">
                      <CheckCircleFill className="icon" size={40} />
                      <h2>Goodie Bag Collected</h2>
                    </div>
                  </div>
                  <div className="details-grid">
                    {Object.entries(ticket)
                      .filter(([key]) => allowedFields.includes(key))
                      .map(([key, value]) => (
                        <div className="detail-item" key={key}>
                          <span className="key">{key}</span>
                          <span className="value">
                            {key === "club" ? (
                              <div className="club-view-button">
                                <span>{value}</span>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => fetchClubMembers(value)}
                                >
                                  View Club
                                </button>
                              </div>
                            ) : (
                              value
                            )}
                          </span>
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                <div className="club-members-section">
                  <div className="club-members-header">
                    <h4>{ticket.club} Members</h4>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowClubMembers(false)}
                    >
                      Back to Details
                    </button>
                  </div>
                  <div className="table-responsive club-members-table">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Rider</th>
                          <th className="text-center">Goodie Bag Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clubMembers.map((member) => (
                          <tr key={member.id}>
                            <td>
                              <div className="rider-info">{member.name}</div>
                              <div className="rider-pnr">{member.riderprofile}</div>
                            </td>
                            <td className="text-center check-in-status">
                              {member.goodieBagStatus ? (
                                <PersonCheckFill
                                  className="icon-success"
                                  size={24}
                                  onClick={() => removeStatusChecked(member.id)}
                                />
                              ) : (
                                <PersonCheck
                                  className="icon-warning"
                                  size={24}
                                  onClick={() => updateStatusChecked(member.id)}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{height: '80vh'}}>
            <h3>404 Page Not Found</h3>
          </div>
        )}
      </div>
    <Footer />
    </>
  );
};

export default GoodieBagDetails;
